import { lazyRetry } from "utils/lazyRetry";

import { PAGE_URLS } from "../constants/PageUrls";

import type { Route } from "routes/RouteModel";

const Details = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "CheckoutBranding" */
      "../pages/Details"
    ),
  "CheckoutBranding"
);
const Edit = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "CheckoutBranding" */
      "../pages/Edit"
    ),
  "CheckoutBranding"
);

export const checkoutBrandingRoutes: Route[] = [
  {
    i18nName: "Update checkout branding",
    path: PAGE_URLS.edit,
    component: Edit,
  },
  {
    i18nName: "Checkout branding",
    path: PAGE_URLS.details,
    component: Details,
  },
];
